import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";

import { RouterModule } from "@angular/router";

import { HttpClientModule } from "@angular/common/http";

import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";

import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha";
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from "ng-recaptcha";

import {
    LazyLoadImageModule,
    intersectionObserverPreset,
} from "ng-lazyload-image";
// import { LazyLoadImageModule, scrollPreset } from 'ng-lazyload-image';
import {NoPasteDirective} from '../distribution/album-distribution/no-paste.directives';
import { FileSaverModule } from "ngx-filesaver";
import { SearchFilterPipe } from "../services/search-filter.pipe";
import { SubscriptionWidgetDirective } from '../subscription-widget.directive';

import { MatSelectModule } from "@angular/material/select";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDividerModule } from "@angular/material/divider";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DragDropModule } from "@angular/cdk/drag-drop";



import { SafePipe } from "../services/safe.pipe";

import { ClapComponent } from "../components/clap/clap.component";

import { YoutubeDialogComponent } from "../components/youtube-dialog/youtube-dialog.component";
import { ReportDialogComponent } from "../components/report-dialog/report-dialog.component";
import { VerifyEmailComponent } from "../components/verify-email/verify-email.component";
import { VerifyPhoneComponent } from "../components/verify-phone/verify-phone.component";
import { LoginDialogComponent } from "../components/login-dialog/login-dialog.component";
import { RegisterComponent } from "../components/register/register.component";
import { PlaylistDialogComponent } from "../components/playlist-dialog/playlist-dialog.component";
import { ShareDialogComponent } from "../components/share-dialog/share-dialog.component";
// import { CartDialogComponent } from "../components/cart-dialog/cart-dialog.component";
//  Commented as it is not used anywhere in the codebase and is causing unnecessary increase in the bundle size. Will be added back when needed.
import { CustomDialogComponent } from "../components/custom-dialog/custom-dialog.component";
import { UpgradeAccountDialogComponent } from "../components/upgrade-account/upgrade-account-dialog.component";

import { FooterComponent } from "../components/footer/footer.component";
import { PlayerComponent } from "../components/player/player.component";

import { BreadcrumbComponent } from "../components/breadcrumb/breadcrumb.component";
import { FollowComponent } from "../components/follow/follow.component";
import { ContentBannerComponent } from "../components/content-banner/content-banner.component";
import { EngBannerComponent } from "../components/eng-banner/eng-banner.component";

import { SongWidgetV2Component } from "../components/song-widget-v2/song-widget-v2.component";
import { VideoWidgetV2Component } from "../components/video-widget-v2/video-widget-v2.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatChipsModule } from "@angular/material/chips";

import { OppWidgetV2Component } from "../components/opp-widget-v2/opp-widget-v2.component";
import { OppWidgetComponent } from "../components/opp-widget/opp-widget.component";
import { WhatsappWidgetsComponent } from "../whatsapp-widgets/whatsapp-widgets.component";

import { ArtistWidgetComponent } from "../components/artist-widget/artist-widget.component";

import { EpkDialogComponent } from "../profile/components/epk-dialog/epk-dialog.component";
import { EpkGalleryDialogComponent } from "../components/epk-gallery-dialog/epk-gallery-dialog.component";
import { ReleasesComponent } from "../releases/releases.component";
import { ReleasesListComponent } from "../releases/releases-list/releases-list.component";
import { ReleasesDetailComponent } from "../releases/releases-detail/releases-detail.component";

@NgModule({
    declarations: [
        SafePipe,
        NoPasteDirective,
        ClapComponent,
        FooterComponent,
        PlayerComponent,
        BreadcrumbComponent,
        FollowComponent,
        ContentBannerComponent,
        EngBannerComponent,
        SongWidgetV2Component,
        VideoWidgetV2Component,
        OppWidgetV2Component,
        OppWidgetComponent,
        ArtistWidgetComponent,
        LoginDialogComponent,
        RegisterComponent,
        YoutubeDialogComponent,
        PlaylistDialogComponent,
        ShareDialogComponent,
        // CartDialogComponent, Commented as it is not used anywhere in the codebase and is causing unnecessary increase in the bundle size. Will be added back when needed.
        ReportDialogComponent,
        UpgradeAccountDialogComponent,
        CustomDialogComponent,
        VerifyEmailComponent,
        VerifyPhoneComponent,
        SearchFilterPipe,
        EpkDialogComponent,
        EpkGalleryDialogComponent,
        ReleasesComponent,
        ReleasesListComponent,
        ReleasesDetailComponent,
        SubscriptionWidgetDirective,
        WhatsappWidgetsComponent,
    ],

    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        LazyLoadImageModule.forRoot({
            preset: intersectionObserverPreset,
        }),
        // LazyLoadImageModule.forRoot({
        //     preset: scrollPreset
        // }),
        FileSaverModule,
        MatSelectModule,
        MatInputModule,
        MatProgressBarModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatSidenavModule,
        MatSliderModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        DragDropModule,
        MatChipsModule,
        MatExpansionModule,


    ],

    exports: [
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        LazyLoadImageModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        FileSaverModule,
        MatSelectModule,
        MatInputModule,
        MatProgressBarModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatSidenavModule,
        MatSliderModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        MatExpansionModule,
        DragDropModule,
        SafePipe,
        SearchFilterPipe,
        ClapComponent,
        FooterComponent,
        PlayerComponent,
        BreadcrumbComponent,
        FollowComponent,
        ContentBannerComponent,
        EngBannerComponent,
        SongWidgetV2Component,
        VideoWidgetV2Component,
        OppWidgetV2Component,
        OppWidgetComponent,
        ArtistWidgetComponent,
        LoginDialogComponent,
        RegisterComponent,
        YoutubeDialogComponent,
        PlaylistDialogComponent,
        ShareDialogComponent,
        // CartDialogComponent, Commented as it is not used anywhere in the codebase and is causing unnecessary increase in the bundle size. Will be added back when needed.
        ReportDialogComponent,
        UpgradeAccountDialogComponent,
        CustomDialogComponent,
        VerifyEmailComponent,
        VerifyPhoneComponent,
        ReleasesComponent,
        ReleasesListComponent,
        ReleasesDetailComponent,
        EpkDialogComponent,
        EpkGalleryDialogComponent,
        WhatsappWidgetsComponent,
        SubscriptionWidgetDirective,
        NoPasteDirective,
    ],

    providers: [
        DatePipe,
        SafePipe,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: { siteKey: '6LeK04kUAAAAAEQYRYhNMMKah7tIZvDioxMn9wCE' } as RecaptchaSettings,
        }
    ]
})

export class SharedModule { }
